var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoNLinze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 40,
    viewBox: "0 0 46 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9998 34.0571C45.9998 37.3367 43.3139 39.997 40.0028 39.997C36.6918 39.997 34.0059 37.3367 34.0059 34.0571C34.0059 30.7775 36.6899 28.1172 40.0028 28.1172C43.3158 28.1172 45.9998 30.7775 45.9998 34.0571Z",
    fill: "#7100FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9939 34.061C11.9939 37.3406 9.30803 40.0009 5.99697 40.0009C2.68591 40.0009 0 37.3406 0 34.061C0 30.7814 2.68404 28.1211 5.99697 28.1211C9.30991 28.1211 11.9939 30.7814 11.9939 34.061Z",
    fill: "#7100FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1316 26.8149C37.369 26.8149 35.1285 24.5976 35.1285 21.8594C35.1285 15.2706 29.7155 9.90912 23.0634 9.90912C16.4114 9.90912 10.9984 15.2706 10.9984 21.8594C10.9984 24.5957 8.7598 26.8149 5.99528 26.8149C3.23076 26.8149 0.992188 24.5976 0.992188 21.8594C0.992188 9.8053 10.8936 0 23.0616 0C35.2296 0 45.131 9.80715 45.131 21.8594C45.131 24.5957 42.8905 26.8149 40.1279 26.8149",
    fill: "#7100FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNLinze);
export default __webpack_public_path__ + "static/media/logoNLinze.9c6791bbbba93c54c1cd4e9743ae6f03.svg";
export { ForwardRef as ReactComponent };